import { useEffect } from "react"
import { useCookies } from "react-cookie"

export const getCookieExpiry = () => {
  const currentDate = new Date()
  const nextYear = new Date(currentDate)
  nextYear.setFullYear(currentDate.getFullYear() + 1)
  return nextYear
}

const AttributionCookie = ({ name }) => {
  const [, setCookie] = useCookies([name])

  useEffect(() => {
    const queryString = typeof window !== "undefined" ? window.location.search : ""
    const value = new URLSearchParams(queryString).get(name)

    if (value) {
      setCookie(name, value, { path: "/", expires: getCookieExpiry() })
    }
  }, [name, setCookie])

  return null
}

export default AttributionCookie
